import React, { useCallback, useState } from "react";

import MenuDropdown from "../../MenuDropdown/MenuDropdown";
import MenuTrigger from "../../MenuTrigger/MenuTrigger";
import * as AuthUtils from "../../../../lib/util/AuthUtils";
import * as FleetSelectors from "../../../../store/Fleet/Fleet.selector";
import * as UserSelectors from "../../../../store/User/User.selector";
import { useSelector } from "../../../../lib/hook/ReduxHooks";
import * as NavigationUtils from "../../../../lib/util/NavigationUtils";
import * as GlobalActions from "../../../../store/Global/Global.action";
import { useDispatch } from "../../../../lib/hook/ReduxHooks";
import Text from "../../../common/Text/Text";

const NavFleets = () => {
	const { allFleets, fleetId, fleet } = useSelector((state) => ({
		fleet: UserSelectors.selectCurrentScopeFleet(state).value,
		fleetId: UserSelectors.selectCurrentScopeFleetId(state),
		allFleets: FleetSelectors.getAllFleetsWithoutDemo(state).value,
	}));

	const dispatch = useDispatch();

	const items = Object.values(allFleets || {}).map((fleet) => ({
		id: fleet.id,
		displayName: fleet.name,
		pathName: "#",
	}));

	const handleSelectFleet = useCallback(
		(option) => {
			if (fleetId !== option.id) {
				NavigationUtils.go("/home");
				dispatch(
					GlobalActions.setScope({
						fleetId: option.id,
						group: null,
					}),
				);
			}
		},
		[dispatch, fleetId],
	);

	if (!AuthUtils.isMultiFleet()) {
		return null;
	}

	return (
		<MenuDropdown items={items} onSelect={handleSelectFleet}>
			<MenuTrigger className={"Navigation__fleets-trigger"}>
				<Text>{fleet?.name}</Text>
			</MenuTrigger>
		</MenuDropdown>
	);
};

export default NavFleets;
